import styled from "styled-components";

export const Wrapper = styled.section`
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  height: 100%;
  h2 {
    font-size: 32px;
    font-style: normal;
    font-weight: 400;
    line-height: 41.6px;
    margin-bottom: 12px;
  }
  button {
  padding: 12px 32px;
  background: #004ea3;
  border-radius: 4px;
  font-weight: 600;
  font-size: 20px;
  line-height: 30px;
  color: #ffffff;
  display: block;
  margin: 0 auto;
  margin-top: 24px;
  cursor: pointer;

  }
`;
